export default __webpack_public_path__ + "static/media/empty-result.d1bda006.png";